import React from 'react';
import { SlaState } from '../../shared/ui-models/lead.ui-model';
import { CHIP } from './lead-visuals';

/**
 * Brand colours, and a dot so the state survives a screenshot, a projector or
 * a colour-blind reader — the difference between "at risk" and "breached"
 * matters too much to carry on hue alone.
 */
const STYLE: Record<SlaState, { label: string; chip: string; dot: string; title: string }> = {
  [SlaState.MET]: {
    label: 'Met',
    chip: 'bg-primary-50 text-primary-700',
    dot: 'bg-action-success',
    title: 'Answered inside the target'
  },
  [SlaState.BREACHED]: {
    label: 'Breached',
    chip: 'bg-secondary-50 text-secondary-700',
    dot: 'bg-action-danger',
    title: 'Answered late, or still unanswered past the target'
  },
  [SlaState.AT_RISK]: {
    label: 'At risk',
    chip: 'bg-creams-500 text-creams-900',
    dot: 'bg-action-alert',
    title: 'Unanswered and close to the target'
  },
  [SlaState.AWAITING]: {
    label: 'Awaiting',
    chip: 'bg-blue text-neutral-500',
    dot: 'bg-primary-400',
    title: 'Unanswered and comfortably inside the target'
  },
  [SlaState.UNKNOWN]: {
    label: '—',
    // Grey and unalarming on purpose: no target was recorded, which is not the
    // same as a missed one and must not read like a breach.
    chip: 'bg-neutral-50 text-neutral-300',
    dot: 'bg-neutral-100',
    title: 'No SLA target recorded for this lead'
  }
};

export const SlaBadge: React.FC<{ state: SlaState }> = ({ state }) => {
  const style = STYLE[state];
  return (
    <span className={`${CHIP} gap-1.5 ${style.chip}`} title={style.title}>
      <span className={`h-1.5 w-1.5 rounded-full ${style.dot}`} />
      {style.label}
    </span>
  );
};
